import { MfeReactComponent } from '@carvana/microfrontend-react';
import { commonEnvironment } from '~/constants/environment';

export default function Footer() {
  return (
    <MfeReactComponent
      component="default"
      module="FooterModule"
      environment={commonEnvironment}
      withoutProvider
    />
  );
}
